<template>
  <div class="fotersa">
    <div class="head-input">
      <a-form :layout="formLayout">
        <a-row :gutter="24" type="flex" justify="start">
          <a-col :span="6" class="fl2 fw">
            <a-form-item
              label="图片状态"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-select
                style="width: 160px"
                :allowClear="true"
                v-model="imgStatus"
                placeholder="请选择"
              >
                <a-select-option
                  v-for="item in dictStatus"
                  :key="item.busCode"
                  :value="item.busCode"
                >
                  {{ item.busName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="4" class="oper">
            <div style="height: 41px; line-height: 41px">
              <a-button type="primary" @click="searchList(1)">查询</a-button>
              <a-button type="primary" ghost @click="addModal()" style="margin-left: 10px;">添加</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>


    <!-- 展示内容 -->
    <div class="base-content">
      <a-table
        :columns="columns"
        :rowKey="
          (record, index) => {
            return index;
            tableData;
          }
        "
        :data-source="tableData"
        :pagination="false"
        bordered
        size="small"
        :scroll="{ x: 1000, y: 'calc(100vh - 250px)' }"
        :loading="tableLoading"
      >
        <div slot="index" slot-scope="text, record, index">
          {{index + (pageNum-1) * pageSize + 1}}
        </div>
        <span slot="imgStatus" slot-scope="text, record">
          <span v-if="record.imgStatus == 1"><a-badge color="cyan" /></span>
          <span v-else-if="record.imgStatus == 2"><a-badge color="red" /></span>
          <span v-else-if="record.imgStatus == 3"><a-badge color="orange" /></span>
          {{ record.imgStatus | DictionaryFilter("USE_STATUS") }}
        </span>
        <span slot="fileType" slot-scope="text, record">
          {{ record.fileType | DictionaryFilter("CHART_TYPE") }}
        </span>
        <span slot="imgUrl" slot-scope="text, record">
            <img
              v-if="record.imgUrl != null && record.fileType == '01'"
              style="height: 50px;max-width: 100%; margin-right: 4px"
              :src="url + record.imgUrl"
              @click="handleImg(record.imgUrl)"
            />
            <a-icon  
            v-if="record.imgUrl != null && record.fileType == '02'" type="video-camera" theme="filled"
            :style="{ fontSize: '25px'}"
            />
        </span>
        <!-- 操作 -->
        <div slot="operation" slot-scope="text">
          <a @click="onUpdate(text)">编辑</a>
          <a @click="handleDelete(text)">删除</a>
        </div>
      </a-table>
      <a-modal
        :visible="previewVisible"
        :footer="null"
        @cancel="handleCancelImg"
        class="imgBox"
      >
        <img alt="example" style="width: 100%" :src="previewImage" />
      </a-modal>
      <!-- 分页 -->
      <div class="base-pagination">
        <a-pagination
        class="table_pagination"
        show-size-changer
        :default-current="1"
        v-model="pageNum"
        :show-total="(totalRows) => `共 ${totalRows} 条`"
        :page-size-options="pageSizeOptions"
        size="small"
        :total="totalRows"
        @showSizeChange="onShowSizeChange"
        @change="paginationChange"
        :page-size.sync="pageSize"
        />
      </div>
      <!-- 确定新增 + 编辑 -->
      <a-modal
        v-model="visible"
        on-ok="handleOk"
        width="1000px"
        :destroyOnClose="true"
        :maskClosable="false"
        v-if="visible"
        @cancel="handleCancel"
      >
      <div slot="title" class="tip-icon"> {{Title}} </div>
        <template slot="footer">
          <a-button
            key="submit"
            class="btaction"
            :loading="loading"
            @click="handleOk"
            :disabled="disabled"
          >
            确认
          </a-button>
        </template>
        <div class="add-mess">
          <a-form-model
            ref="ruleForm"
            :model="form"
            :rules="rules"
            class="input-input"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
          >
            <a-row>
              <a-col :span="12">
                <a-form-model-item ref="routeUrl" label="跳转路径" prop="routeUrl">
                  <a-input
                    :disabled="disabled"
                    v-model="form.routeUrl"
                    placeholder="请输入跳转路径"
                  />
                </a-form-model-item>
              </a-col>

              <a-col :span="12">
                <a-form-model-item ref="description" label="图片描述" prop="description">
                  <a-input
                    :disabled="disabled"
                    v-model="form.description"
                    placeholder="请输入图片描述"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item
                  ref="imgStatus"
                  label="图片状态"
                  prop="imgStatus"
                >
                  <a-select
                    v-model="form.imgStatus"
                    placeholder="请选择图片状态"
                  >
                    <a-select-option
                      v-for="item in dictStatus"
                      :key="item.busCode"
                      :value="item.busCode"
                      >{{ item.busName }}</a-select-option
                    >
                  </a-select>
                </a-form-model-item>
              </a-col>

              <a-col :span="12">
                <a-form-model-item
                  ref="fileType"
                  label="文件类型"
                  prop="fileType"
                >
                  <a-select
                    v-model="form.fileType"
                    placeholder="请选择文件类型"
                  >
                    <a-select-option
                      v-for="item in typeStatus"
                      :key="item.busCode"
                      :value="item.busCode"
                      >{{ item.busName }}</a-select-option
                    >
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
            <a-col :span="12">
                <a-form-model-item
                  ref="imgOrder"
                  label="排序"
                  prop="imgOrder"
                >
                  <a-input-number
                    style="width: 100%"
                    :disabled="disabled"
                    v-model="form.imgOrder"
                    placeholder="请输入排序"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                prop="imgUrl"
                  label="展示文件"
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 20 }"
                >
                 <upload :downid="id" uploadNum="1" :uploadAgain="uploadAgain" :fileType="fileType" :fileNum="fileNum" @listen ="listen"></upload>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </div>
      </a-modal>
    </div>
  </div>
</template>
<script>
import upload from "@/components/upload/upload.vue";
import {
  getId,
  serStatus,
  uploadFile,
  gretRotationChartById,
  addRotationChart,
  queryRotationChart,
  delRotationChart,
  updateRotationChart,
  deleFile,
} from "@/api/api.js";
import { DictionaryService } from "@common/services/dictionary.service";
import moment from "moment";
moment.locale("zh-cn");

export default {
 
  components: { upload },
  data() {
    //自定义校验规则
    var checkAge = (rule, value, callback) => {
      if (value) {
        if (value > 99999999) {
            return callback(new Error('排序不能超过8位数'));
        } else {
          if (!Number.isInteger(value)) {
            return callback(new Error('请输入整数'));
          } else {
            return callback();
          }
        }
      } else {
        return callback();
      }
    };
    return {
      id:"",
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      description: "", //图片描述
      imgStatus: undefined,  //图片状态
      tableData: [],  //表格数据
      Title: "",      //弹框标题
      visible: false, //新增弹出框
      // 表单验证
      rules: {
        imgStatus: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change",
          },
        ],
        fileType: [
          {
            required: true,
            message: "请选择文件类型",
            trigger: "change",
          },
        ],
        routeUrl: [
        {
            max: 450,
            message: "跳转路径长度不能超过450",
          },
        ],
        description: [
        {
            max: 450,
            message: "图片描述长度不能超过450",
          },
        ],
        imgOrder: [
          {
            validator: checkAge,
            trigger: "change",
          },
          {
            required: true,
            message: "请输入排序",
            trigger: "blur",
          },
        ],
        imgUrl: [{
          required: true,
          message: "请上传图片",
        }]
      },
      form: {
        imgUrl: "1",
        routeUrl: "",
        imgStatus: undefined,
        fileType: "01",
        description: "",
        imgOrder: ""
      },
      //组件列表是否存在
      imgUrl :'',
      imgId :[],
      loading: false,
      disabled: false,
      //数列
      columns: [
        {
          title: "序号",
          align: "center",
          dataIndex: "index",
          width: 23,
          key: "index",
          ellipsis: true,
          scopedSlots: { customRender: "index" },
        },
        {
          title: "轮播展示",
          align: "center",
          dataIndex: "imgUrl",
          width: 127,
          scopedSlots: { customRender: "imgUrl" },
        },
        {
          title: "文件类型",
          dataIndex: "fileType",
          key: "fileType",
          align: "center",
          ellipsis: true,
          width: 50,
          scopedSlots: { customRender: "fileType" },
        },
        {
          title: "跳转路径",
          dataIndex: "routeUrl",
          key: "routeUrl",
          align: "center",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "routeUrl" },
        },
        {
          title: "状态",
          dataIndex: "imgStatus",
          key: "imgStatus",
          align: "center",
          ellipsis: true,
          width: 50,
          scopedSlots: { customRender: "imgStatus" },
        },
        {
          title: "图片描述",
          dataIndex: "description",
          key: "description",
          align: "center",
          ellipsis: true,
          width: 90,
          scopedSlots: { customRender: "description" },
        },

        {
          title: "排序",
          dataIndex: "imgOrder",
          key: "imgOrder",
          align: "center",
          ellipsis: true,
          width: 40,
          scopedSlots: { customRender: "imgOrder" },
        },
        {
          title: "操作",
          key: "operation",
          align: "center",
          width: 40,
          scopedSlots: {
            customRender: "operation",
          },
        },
      ],
      pageNum: 1,
      pageSize: 10,
      totalRows: 0,
      totalPages: 0,
      pageSizeOptions: ["10", "20", "50", "100"],
      dictStatus: [],
      typeStatus: [],
      formLayout: "horizontal",
      url: "",
      previewVisible: false,
      previewImage: "",
      bigurl: "",
      uploadAgain:false,
      fileNum: 0,
      fileType:'01',//文件类型
      //查询加载
      tableLoading:false,
    };
  },

  watch: {
    Title(newVal, oldVal) {
      if ((oldVal === "轮播图修改") && this.visible == true) {
        if (newVal == "轮播图添加") {
          this.form = this.$options.data().form;
        }
      }
    },
    //监听文件类型变化
    'form.fileType':function (newVal) {
      this.fileType = newVal;
      this.listen("change");
    }
  },
  mounted() {
    DictionaryService.getAllNeedDic(["USE_STATUS","CHART_TYPE"]).then((res) => {
      this.dictStatus = DictionaryService.getOptions("USE_STATUS");
      this.typeStatus = DictionaryService.getOptions("CHART_TYPE");
      this.searchList(1);
    });
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
          }
        : {};
    },
  },
  methods: {
     //获取ID（附件ID）
     getIds() {
      let pageParam = {
        pageNum: 0,
        pageSize: 0,
        orderBy: "",
      };
      getId({ pageParam: pageParam }).then((res) => {
        this.id = res.content.id;
        this.disabled = false;
        this.visible = true;
        this.Title = "轮播图添加";
      },
      (err) => {
        this.$message.success("获取id失败");
      });
    },
    //监听附件组件
    listen(val) {
      this.fileType = this.form.fileType;
      this.uploadAgain = false;
      if(val != "change"){
        if(val.length == 0){
          this.imgUrl = false;
        } else {
          this.imgUrl = true;
          this.imgId = val[0].id;
          this.uploadAgain = true;//监听是否已上传文件
        }
        this.fileNum = val.length;
      }
    },
    /* 表格图片查看 */
    handleImg(file) {
      this.previewVisible = true;
      this.bigurl = process.env.VUE_APP_PROXY + "base/file/download-file?id=";
      this.previewImage = this.bigurl + file;
    },
    /* 表格图片关闭 */
    handleCancelImg() {
      this.previewVisible = false;
    },
    //分页
    paginationChange(page, pageSize) {
      this.pageNum = page;
      this.searchList();
    },
    onShowSizeChange(current, size) {
      this.pageSize = size;
      this.pageNum = 1;
      this.searchList();
    },
    //列表查询
    searchList(sum = 2) {
      this.url = process.env.VUE_APP_PROXY + "base/file/download-file?id=";
      if (sum == 1) this.pageNum = 1;
      let obj = {
        pageParam: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          orderBy: "",
        },
        content: {
          description: this.description,
          imgStatus: this.imgStatus,
        },
      };
      this.tableLoading = true;
        queryRotationChart(obj).then((res) => {
            this.tableData = res.content.rows;
            this.totalRows = res.content.page.totalRows;
            this.totalPages = Math.ceil(this.totalRows / this.pageSize);
            this.tableLoading = false;
        }).catch((err) => {
            if (err.message) {
              this.$message.error(err.message);
            } else {
              this.$message.error("网络请求异常");
            }
            this.tableLoading = false;
          });
    },
    // 关闭箭头的回调
    handleCancel(e) {
      this.id = ''
      this.$refs["ruleForm"].resetFields();
      this.form.remark = "";
    },
    //新增弹窗
    addModal() {
      this.getIds();
    },
    onUpdate(key) {
      this.disabled = false;
      this.visible = true;
      this.Title = "轮播图修改";
      gretRotationChartById({ id: key.id }).then((res) => {
      this.form.id = res.content.id;
      this.form.imgUrl = res.content.imgUrl;
      this.form.routeUrl = res.content.routeUrl;
      this.form.imgStatus = res.content.imgStatus;
      this.form.fileType = res.content.fileType;
      this.form.description = res.content.description;
      if(res.content.imgOrder === null || res.content.imgOrder === ""){
        this.form.imgOrder = "";
      }else{
        this.form.imgOrder = parseInt(res.content.imgOrder);
      }
      this.form.pgStatus = res.content.pgStatus;
      this.id = res.content.id;
      }) 
    },
    // 确定新增 + 编辑
    handleOk(e) {
      if (this.imgUrl) {
        this.loading = true;
      // 判断是新增还是编辑
        if (this.Title == "轮播图修改") {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            updateRotationChart({
              id: this.form.id,
              imgUrl: this.imgId,
              routeUrl: this.form.routeUrl,
              fileType:this.form.fileType,
              description: this.form.description,
              imgStatus: this.form.imgStatus,
              imgOrder: this.form.imgOrder,
            }).then(
              (res) => {
                this.$nextTick(() => {
                  this.$refs["ruleForm"].resetFields();
                });

                this.visible = false;
                this.loading = false;
                this.searchList();
                this.$message.success("修改成功");
                this.id = '';
              },
              (err) => {
                this.loading = false;
              }
            );
          } else {
            this.loading = false;
            return false;
          }
        });
      } else if (this.Title == "轮播图添加") {
          // 校验表单
          this.$refs.ruleForm.validate((valid) => {
            if (valid) {
            //添加轮播图记录
            addRotationChart({
              id: this.id,
              imgUrl: this.imgId,
              routeUrl: this.form.routeUrl,
              fileType:this.form.fileType,
              description: this.form.description,
              imgStatus: this.form.imgStatus,
              imgOrder: this.form.imgOrder,
            }).then((addRes) => {
              this.loading = false;
                  this.visible = false;
                  this.searchList();
                  this.$message.success("添加成功");
                  this.form.remark = "";
                  this.$refs["ruleForm"].resetFields();
                  this.id = '';
            }).catch((err) => {
                this.loading = false;
                if (err.message) {
                  this.$message.error(err.message);
                } else {
                  this.$message.error("网络请求异常");
                }
              });
            } else {
              this.loading = false;
              return false;
            }
          });
      }
      } else {
        this.$message.error("请上传图片");
      }
    },

    //删除
    handleDelete(text) {
      this.$confirm({
        title: "确定是否删除?",
        okText: "是",
        cancelText: "否",
        onOk: () => {
            //删除轮播图数据和附件
            delRotationChart({
              id: text.id 
            }).then((res)=>{
              this.$message.success("删除成功");
              //删除之后跳转到第一页
              this.pageNum = 1;
              this.searchList();
            }).catch((err) => {
              if (err.message) {
                this.$message.error(err.message);
              } else {
                this.$message.error("网络请求异常");
              }
            });
        },
        onCancel: () => {},
      });
    },
  },
};
</script>
<style lang="less" scoped="scoped">
.base-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/.ant-table-body {
  margin-top: -8px !important;
}
.sp_name {
  display: inline-block;
  font-size: 20px;
  margin: 0 0 20px 10px;
}
.fotersa {
  width: 100%;
  height: 100%;
  overflow-y: hidden;
  .title-name {
    width: 100%;
    height: 46px;
    overflow: hidden;
    .sp_name {
      display: inline-block;
      font-size: 20px;
      margin: 0 0 20px 10px;
    }
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .flex label {
    font-size: 16px;
    width: 73px;
  }
  .btone {
    margin-left: 10px;
  }
  .bttwo {
    margin-left: 10px;
  }

  a {
    margin-left: 10px;
  }
  a:hover {
    color: #70b9cf;
  }
}
/deep/.ant-form-item {
  margin-bottom: 0;
}
.title-name::before {
  content: "";
  width: 5px;
  height: 20px;
  display: inline-block;
  overflow: hidden;
  background-color: #0b2464;
}
/deep/ .ant-table-body {
  max-height: 487px;
  overflow: auto;
  margin: 0 !important;
}
/deep/.ant-table-tbody > tr > td {
  padding: 11px 16px;
}

.add-mess {
  width: 100%;
  //overflow: auto;

  /deep/ .ant-form-item {
    display: flex;
    margin-bottom: 20px !important;
  }
  /deep/ .ant-form-item-label {
    width: 150px;
  }

}
/deep/ .form .ant-input,
.ant-form-item-control,
.ant-form-item-control-wrapper {
  width: 160px;
}
.fw {
  width: 245px;
}
.oper {
  // flex: 1;
  width: 200px;
}
/deep/ .fl .ant-row .ant-col-6:nth-child(1) {
  width: 76px;
}
/deep/ .fl1 .ant-row .ant-col-6:nth-child(1) {
  width: 72px;
}
/deep/ .fl2 .ant-row .ant-col-6:nth-child(1) {
  width: 68px;
}
/deep/ .ant-input-affix-wrapper {
  width: 160px;
}
/deep/ .ant-col-18 {
  width: 65%;
}
/deep/ .ant-col-12 {
  width: 45%;
}
/deep/.ant-col-20 {
  width: 82%;
}

.table_pagination {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.base-pagination{
  float: right;
}

.base-content{
  margin-top: 10px;
}
</style>